export default "__VITE_ASSET__D9_ByoL0__"